(function ($, Drupal, once) {

  'use strict';

  const container = document.querySelector('.js-qq-container');

  // Exit on pages where the container does not exist.
  if (!container) return;

  const select = container.querySelector('.js-qq-menu-toggler');
  const current = container.querySelector('.js-qq-current');
  const menu = container.querySelector('.js-qq-menu');

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.quickQuote = {
    /**
     * Display the product options popup.
     */
    showOptionsMenu: function() {
      select.setAttribute('aria-expanded', true);
      menu.toggleAttribute('hidden');
      setTimeout(_ => { menu.classList.remove('quick-quote__menu--hidden'); }, 1); // Timeout to allow transition trigger.
    },

    /**
     * Hide the product options popup.
     */
    hideOptionsMenu: function() {
      select.setAttribute('aria-expanded', false);
      menu.classList.add('quick-quote__menu--hidden');
      setTimeout(_ => { menu.toggleAttribute('hidden', true); }, 200); // Timeout to allow transition trigger.
      document.body.style.overflowY = '';
    },

    /**
     * Get all available options.
     */
    getOptions: function () {
      return container.querySelectorAll('.js-qq-menuitem');
    },

    /**
     * Select a quick-quote option and update links accordingly.
     */
    selectOption: function (qqOption) {
      // Select current item in the main box.
      copy('.js-qq-title');
      copy('.js-qq-icon', { contentOnly: false });
      if (qqOption.querySelector('.js-qq-time')) {
        copy('.js-qq-time');
        current.querySelector('.qtimer').classList.remove('visually-hidden');
      }
      else {
        current.querySelector('.qtimer').classList.add('visually-hidden');
      }
      copy('.js-qq-unit');
      current.querySelector('.js-qq-submit').href = qqOption.href;
      menu.querySelector('.js-qq-submit').href = qqOption.href;

      // Toggle current selection in the menu.
      this.getOptions().forEach(item => {
        item.setAttribute('aria-checked', false);
      });
      qqOption.setAttribute('aria-checked', true);

      // Shortcut function.
      function copy(selector, options) {
        copyOver(
          qqOption.querySelector(selector),
          current.querySelector(selector),
          options,
        );
      }
    },
  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_quickquote = {
    attach: function attach(context) {

      /**
       * Manage the pop-up menu for quote type selection.
       */
      $(once('promutuelQuickQuoteMenu', '.js-qq-container', context)).each(function() {
        // Add extra padding on the footer to accomodate the quick quote bar.
        document.querySelector('.footer__bottom').classList.add('footer__bottom--sticky-bar');

        // Main selector click handler.
        select.addEventListener('click', function (event) {
          // On mobile: make sure the header is visible at the top of the screen.
          if (Promutuel.responsive.getCurrentSize() < Promutuel.responsive.BREAKPOINTS.LG) {
            Promutuel.header?.show();
            document.body.style.overflowY = 'hidden';
            const headerHeight = document.querySelector('header').offsetTop + document.querySelector('header').offsetHeight;
            menu.style.paddingTop = `${headerHeight}px`;
          }

          Promutuel.quickQuote.showOptionsMenu();
          menu.querySelector('.js-qq-menuitem[aria-checked="true"]').focus(); /* keyboard accessibility */
          event.preventDefault();
          event.stopPropagation();
        });

        document.body.addEventListener('click', function (event) {
          Promutuel.quickQuote.hideOptionsMenu();
        });

        const menuItems = container.querySelectorAll('.js-qq-menuitem');

        menuItems.forEach(item => {
          // Menu click handler.
          item.addEventListener('click', function (event) {
            Promutuel.quickQuote.selectOption(item);

            // Close menu (on desktop only)
            if (Promutuel.responsive.getCurrentSize() >= Promutuel.responsive.BREAKPOINTS.LG) {
              Promutuel.quickQuote.hideOptionsMenu();
              container.querySelector('.js-qq-menu-toggler').focus(); /* keyboard accessibility */
            }

            event.preventDefault();
            event.stopPropagation();
          });
        });
      });
    }
  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Utilities
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  /**
   * Clone an element to another place in the DOM.
   *
   * @param from The source element.
   * @param from The target element.
   * @param options JSON object with the following options:
   *        - contentOnly (boolean):
   *          - if true (default), the content of the `from` element is copied into `to`
   *          - if false, the whole `from` element is copied and `to` is replaced with the clone.
   */
  function copyOver(from, to, {contentOnly = true} = {}) {
    if (!from || !to) return;

    if (contentOnly) {
      while(to.firstChild) to.removeChild(to.firstChild);
      from.childNodes.forEach(child => {
        to.appendChild(child.cloneNode(true));
      });
    }
    else {
      to.parentElement.replaceChild(from.cloneNode(true), to);
    }
  }
})(jQuery, Drupal, once);
